module.exports = "/images/ke.svg?da160240238419b5192d290fe867940c";